import React from "react";
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";
import { CartProvider, useCart } from "react-use-cart";
import { Link } from "react-router";

function Cart() {
  const {
    items,
    totalItems,
    totalUniqueItems,
    cartTotal,
    isEmpty,
    removeItem,
    updateItemQuantity,
    emptyCart,
  } = useCart();
  if (isEmpty) {
    return (
      <div className="text-center">
        <br />
        <br />
        <br />
        <img src="/assets/img/emptycart.png" className="w-25"></img>
        <h2 className="text-success">
          Your Cart is Still Empty....
          <Link className="text-decoration-none" to="/shop">
            Shop
          </Link>
        </h2>
      </div>
    );
  }

  return (
    <div>
      <main className="page">
        <section className="shopping-cart dark">
          <div className="container">
            <div className="block-heading">
              <h2 className="text-success d-inline-block">
                Shopping Cart(
                <span className="text-secondary">{totalUniqueItems}</span>)
              </h2>
            </div>
            <div className="content">
              <div className="row">
                <div className="col-md-12 col-lg-8">
                  <div className="items">
                    {items.map((element) => {
                      return (
                        <div className="product">
                          <div className="row">
                            <div className="col-md-3">
                              <img
                                className="img-fluid mx-auto d-block image"
                                src={element.images[0]}
                              />
                            </div>
                            <div className="col-md-8">
                              <div className="info">
                                <div className="row">
                                  <div className="col-md-5 product-name">
                                    <div className="product-name">
                                      <h5 className="text-success">
                                        {element.title}
                                      </h5>
                                      <div className="product-info">
                                        <div>
                                          Rating :
                                          <span className="value">
                                            {" "}
                                            {element.rating} of 5
                                          </span>
                                        </div>
                                        <div>
                                          Brand :{" "}
                                          <span className="value">
                                            {" "}
                                            {element.brand}
                                          </span>
                                        </div>
                                        <div>
                                          Stock :
                                          <span className="value">
                                            {" "}
                                            {element.stock}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-4 quantity">
                                    <label htmlFor="quantity">
                                      <b>Quantity:</b>
                                    </label>
                                    <p>{element.quantity}</p>
                                    <button
                                      className="btn btn-warning"
                                      onClick={() =>
                                        updateItemQuantity(
                                          element.id,
                                          element.quantity - 1
                                        )
                                      }
                                    >
                                      -
                                    </button>
                                    <button
                                      className="btn btn-success mx-2"
                                      onClick={() =>
                                        updateItemQuantity(
                                          element.id,
                                          element.quantity + 1
                                        )
                                      }
                                    >
                                      +
                                    </button>
                                    <button
                                      className="btn btn-danger"
                                      onClick={() => removeItem(element.id)}
                                    >
                                      &times;
                                    </button>
                                  </div>
                                  <div className="col-md-3 price">
                                    <b>
                                      $
                                      {Math.ceil(
                                        element.price * element.quantity
                                      )}
                                    </b>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="col-md-12 col-lg-4">
                  <form method="get">
                    <div className="summary">
                      <h3 className="text-success">Order Form</h3>
                      <input
                        type="text"
                        placeholder="Name"
                        name="user"
                        className="form-control mb-3 rounded-5
                      "
                        required
                      ></input>
                      <input
                        type="email"
                        placeholder="Email"
                        name="email"
                        className="form-control mb-3 rounded-5
                      "
                        required
                      ></input>
                      <input
                        type="text"
                        placeholder="Phone number"
                        name="number"
                        className="form-control mb-3 rounded-5
                      "
                        required
                      ></input>

                      <select
                        required
                        name="governorate"
                        id="governorate"
                        className=" p-2 rounded-5 triangle"
                      >
                        <option value="">Select Governorate</option>
                        <option value="Cairo">Cairo</option>
                        <option value="Giza">Giza</option>
                        <option value="Alexandria">Alexandria</option>
                        <option value="Dakahlia">Dakahlia</option>
                        <option value="Red Sea">Red Sea</option>
                        <option value="Beheira">Beheira</option>
                        <option value="Fayoum">Fayoum</option>
                        <option value="Gharbia">Gharbia</option>
                        <option value="Ismailia">Ismailia</option>
                        <option value="Menoufia">Menoufia</option>
                        <option value="Minya">Minya</option>
                        <option value="Qaliubiya">Qaliubiya</option>
                        <option value="New Valley">New Valley</option>
                        <option value="Suez">Suez</option>
                        <option value="Aswan">Aswan</option>
                        <option value="Assiut">Assiut</option>
                        <option value="Beni Suef">Beni Suef</option>
                        <option value="Port Said">Port Said</option>
                        <option value="Damietta">Damietta</option>
                        <option value="Sharkia">Sharkia</option>
                        <option value="South Sinai">South Sinai</option>
                        <option value="Kafr El Sheikh">Kafr El Sheikh</option>
                        <option value="Matrouh">Matrouh</option>
                        <option value="Luxor">Luxor</option>
                        <option value="Qena">Qena</option>
                        <option value="North Sinai">North Sinai</option>
                        <option value="Sohag">Sohag</option>
                      </select>

                      <input
                        type="text"
                        placeholder="Delivery address"
                        name="address"
                        className="form-control mb-3 rounded-5 mt-3
                      "
                        required
                      ></input>
                      <textarea
                        className="form-control mb-4 rounded-5"
                        placeholder="Notes (optional)"
                      ></textarea>
                      <div className="summary-item">
                        <span className="text">Subtotal</span>
                        <span className="price">${Math.ceil(cartTotal)}</span>
                      </div>
                      <div className="summary-item">
                        <span className="text">Discount</span>
                        <span className="price">$0</span>
                      </div>
                      <div className="summary-item">
                        <span className="text">Shipping</span>
                        <span className="price">$10</span>
                      </div>
                      <div className="summary-item">
                        <span className="text">Total</span>
                        <span className="price">
                          ${Math.ceil(cartTotal + 10)}
                        </span>
                      </div>

                      <div className="text-center">
                        <button
                          className="btn btn-danger mx-1"
                          onClick={() => emptyCart()}
                        >
                          Empty Cart
                        </button>
                        <button
                          type="submit"
                          className="btn btn-success mx-1"
                          onClick={(e) => {
                            e.preventDefault();
                            alert("Your order has been placed successfully!✅");
                          }}
                        >
                          Place Order
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

function AllCart() {
  return (
    <CartProvider>
      <Navbar />
      <br />
      <br />
      <br />
      <Cart />
      <br />
      <br />
      <br />
      <Footer />
    </CartProvider>
  );
}

export default AllCart;
